import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import { Device, from, until } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import IconButtonStyles from '@stories/Components/Buttons/IconButton/IconButton.styles';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  ${setCssVar('accentColor', brand.htaRebrand.green)};
  ${setCssVar('accentColorAlt', rgba(brand.htaRebrand.green, 0.38))};
  ${setCssVar('bgColor', brand.white)};
  ${setCssVar('bgColorAlt', brand.hta.green)};
  ${setCssVar('fgColor', brand.black)};
  ${setCssVar('fgColorAlt', brand.white)};
  position: relative;

  .theme-hta & {
    margin-bottom: 40px;
  }

  .theme-hh & {
    ${setCssVar('accentColor', brand.hortHouse.green)};
    ${setCssVar('accentColorAlt', brand.hortHouse.greenLight)};
    ${setCssVar('bgColor', brand.grey)};
    margin-bottom: 40px;
  }

  .theme-rss & {
    ${setCssVar('accentColor', brand.rss.green)};
    ${setCssVar('accentColorAlt', brand.rss.greenDark)};
    ${setCssVar('bgColor', brand.black)};
    overflow: hidden;
  }

  margin-top: 60px;
  background-color: ${cssVar('bgColor')};

  .theme-hta & {
    padding-bottom: 70px;
    overflow: hidden;

    @media ${until(Device.MobileLarge)} {
      margin-top: 0;
    }

    @media ${from(Device.DesktopSmall)} {
      padding-bottom: 0;
      overflow-y: visible;
      overflow-x: clip;
    }
  }
`;
const Inner = styled.div `
  position: relative;

  @media ${until(Device.Tablet)} {
    display: grid;
    gap: 84px 0 0;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
  }
`;
const ItemList = styled.div `
  display: grid;

  > * {
    grid-area: 1 / 1;
  }

  @media ${until(Device.Tablet)} {
    grid-column: 1 / span 2;
    grid-row: 1;
    margin-bottom: 20px;
  }
`;
const Navigation = styled.div `
  @media ${until(Device.Tablet)} {
    align-self: center;
    grid-column: 1;
    grid-row: 2;
    justify-self: flex-start;
  }

  @media ${from(Device.Tablet)} {
    position: absolute;
    bottom: ${48 + 44}px;
    left: 0;
  }

  .theme-hh & {
    display: none;
  }
`;
const NavigationItem = styled.button `
  display: inline-block;
  background: ${cssVar('accentColorAlt')};
  border: 0;
  border-radius: 50%;
  height: 14px;
  transition: background-color 0.15s ease-out, transform 0.15s ease-out;
  width: 14px;
  padding: 0;

  @media ${from(Device.Tablet)} {
    height: 20px;
    width: 20px;
  }

  & + & {
    margin-left: 8px;
  }

  &[aria-current='true'] {
    background: ${cssVar('accentColor')};
  }

  &:focus,
  &:hover {
    background: ${cssVar('accentColor')};
    transform: scale(1.2);
  }

  > span {
    ${srOnly};
  }
`;
const Controls = styled.div `
  ${IconButtonStyles.Button} + ${IconButtonStyles.Button} {
    margin-left: 8px;
  }

  @media ${until(Device.Tablet)} {
    align-self: center;
    grid-column: 2;
    grid-row: 2;
    justify-self: flex-end;
  }

  @media ${from(Device.Tablet)} {
    position: absolute;
    bottom: 0;
    left: 0;
  }

  .theme-hh & {
    display: none;
  }
`;
const HTAGraphicWrapper = styled.div `
  display: none;

  .theme-hta & {
    display: block;
    position: absolute;
    right: 0;
    top: 15%;
    width: initial;

    @media ${from(Device.Tablet)} {
      top: auto;
      bottom: -40px;
      width: 60%;
    }

    @media ${from(Device.DesktopLarge)} {
      width: initial;
    }
  }
`;
export default {
    Container,
    Controls,
    Inner,
    ItemList,
    Navigation,
    NavigationItem,
    HTAGraphicWrapper,
};
